import { AxiosResponse } from 'axios';
import SceneType from '../../types/admin/scene.type';
import { CommonFilterCriteria, PageRequest, PaginationResponseType } from '../../types/CommonTypes';
import { API_ADMIN_SCENES } from '../../utils/urls';
import { axios } from '../baseAxios';

const url = API_ADMIN_SCENES;

export const getAdminScene = (id: number): Promise<AxiosResponse<SceneType>> =>
  axios.get(`${url}/${id}`);

export const getAdminScenes = (
  params: CommonFilterCriteria & PageRequest
): Promise<AxiosResponse<PaginationResponseType<SceneType>>> => axios.get(url, { params });
